import { ExamPage } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/exam'].update({
        staticData: { title: { page: 'EditExam.Pageheading', forWebinar: true } },
        component: authGuard(ExamPage)
    });
};
